import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.automatedLendingDecision.decisionError.duplicateGuarantorError.title',
        defaultMessage: 'Please pick another guarantor'
    },
    message: {
        id: '_.automatedLendingDecision.decisionError.duplicateGuarantorError.message',
        defaultMessage:
            "They can be a business partner, friend or family member - anyone who's happy, in addition to you, to personally guarantee the repayments will be met. If you {messageChangeOrRemoveGuarantorLink} that, you should be able to continue."
    },
    messageChangeOrRemoveGuarantorLink: {
        id: '_.automatedLendingDecision.decisionError.duplicateGuarantorError.messageChangeOrRemoveGuarantorLink',
        defaultMessage: 'change'
    }
});
